var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 25.2976C21.6969 25.2978 21.9588 25.5587 21.959 25.8806V33.7976H16.042V25.8806C16.0422 25.5587 16.3031 25.2978 16.625 25.2976H21.375ZM19 8.38647C20.7571 8.38647 22.2324 9.65163 25.1826 12.1804L26.7656 13.5369C28.3978 14.9359 29.2139 15.636 29.6484 16.5808C30.083 17.5256 30.083 18.6003 30.083 20.7498V27.4646C30.083 30.4496 30.0834 31.9424 29.1562 32.8699C28.2507 33.7755 26.8057 33.7961 23.959 33.7966V25.8806C23.9588 24.4541 22.8015 23.2978 21.375 23.2976H16.625C15.1985 23.2978 14.0422 24.4541 14.042 25.8806V33.7966C11.1946 33.7961 9.74945 33.7756 8.84375 32.8699C7.91658 31.9424 7.91699 30.4496 7.91699 27.4646V20.7498C7.91699 18.6003 7.91703 17.5256 8.35156 16.5808C8.78613 15.636 9.60217 14.9359 11.2344 13.5369L12.8174 12.1804C15.7676 9.65163 17.2429 8.38647 19 8.38647Z",
    fill: "url(#paint0_linear_71_753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_753",
    x1: 11.0314,
    y1: 12.1321,
    x2: 33.6373,
    y2: 16.9178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BADCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFill);
export default __webpack_public_path__ + "static/media/Home_fill.f8d0951539f857033b3a4d7b7a333d5b.svg";
export { ForwardRef as ReactComponent };